import React,{ useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';


const Login = () =>{
  const navigate = useNavigate();


  return (
    <div>
      <div onClick={()=> navigate('/')}>Login</div>
    </div>
  )
}

export default Login